import { WorkflowResponse } from '@bringg/types';
import { airBrakeNotifier, sentryNotifier } from '@bringg-frontend/bringg-web-infra';

import { workflowsRootStore } from '../stores/internal';
import WorkflowStore from '../stores/workflow-store';
import UnreadableWorkflow from '../stores/unreadable-workflow';
import { isUnreadablePlaceholderEnabled } from '../utils/unreadable-placeholder-flag';
import { Workflow } from '../utils/types';

// One report per workflow per page session: a bad workflow is mapped again on every load and patch.
const reportedWorkflowIds = new Set<number>();

function reportUnreadableWorkflow(error: unknown, workflowId: number | undefined) {
	// An item with no id cannot be told apart from another one, so it is reported every time.
	if (workflowId !== undefined) {
		if (reportedWorkflowIds.has(workflowId)) {
			return;
		}

		reportedWorkflowIds.add(workflowId);
	}

	const reportedError = error instanceof Error ? error : new Error(String(error));

	airBrakeNotifier.notify(reportedError, { workflow_id: workflowId });
	sentryNotifier.notify(reportedError, { workflow_id: workflowId });
}

function map(workflow: WorkflowResponse, params?: { action?: string }) {
	const { workflowRepo } = workflowsRootStore.getStore();
	// the patch api function doesn't return the full object in the response. so need to merge with the existing object.
	const source: Workflow =
		params?.action === 'patch' ? { ...workflowRepo.get(workflow.id).original, ...workflow } : workflow;

	try {
		return { current: new WorkflowStore(source) };
	} catch (error) {
		if (!isUnreadablePlaceholderEnabled()) {
			throw error;
		}

		reportUnreadableWorkflow(error, workflow?.id);

		return { current: new UnreadableWorkflow(source) };
	}
}

export const workflowsStoreMapper = { map };
